import React from "react";

export const GoogleCalendarIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 64 64" fill="none">
			<path
				d="M47.1579 16.8405L33.516 15.3247L16.8422 16.8405L15.3262 31.9985L16.8419 47.1565L31.9999 49.0512L47.1579 47.1565L48.6737 31.6197L47.1579 16.8405Z"
				fill="white"
			/>
			<path
				d="M23.0606 40.3596C21.9276 39.5941 21.1431 38.4764 20.7148 36.9983L23.3449 35.9146C23.5836 36.8241 24.0003 37.5288 24.5954 38.0291C25.1866 38.5294 25.9066 38.7756 26.7479 38.7756C27.6081 38.7756 28.3471 38.5141 28.9646 37.9911C29.5821 37.4681 29.8931 36.8011 29.8931 35.9941C29.8931 35.1681 29.5671 34.4933 28.9154 33.9706C28.2636 33.4479 27.4451 33.1861 26.4674 33.1861H24.9479V30.5829H26.3118C27.1531 30.5829 27.8619 30.3556 28.4379 29.9009C29.0139 29.4461 29.3019 28.8246 29.3019 28.0326C29.3019 27.3279 29.0441 26.7669 28.5289 26.3464C28.0136 25.9259 27.3616 25.7136 26.5696 25.7136C25.7966 25.7136 25.1826 25.9184 24.7278 26.3314C24.2731 26.7444 23.9433 27.2521 23.7351 27.8509L21.1319 26.7671C21.4766 25.7894 22.1096 24.9254 23.0379 24.1789C23.9664 23.4324 25.1523 23.0571 26.5923 23.0571C27.6571 23.0571 28.6158 23.2619 29.4649 23.6749C30.3136 24.0879 30.9806 24.6601 31.4619 25.3876C31.9431 26.1189 32.1819 26.9376 32.1819 27.8469C32.1819 28.7754 31.9584 29.5596 31.5111 30.2038C31.0638 30.8481 30.5143 31.3406 29.8626 31.6856V31.8408C30.7228 32.2008 31.4238 32.7503 31.9771 33.4894C32.5266 34.2284 32.8031 35.1114 32.8031 36.1421C32.8031 37.1729 32.5416 38.0936 32.0186 38.9009C31.4955 39.7081 30.7718 40.3446 29.8548 40.8069C28.9341 41.2691 27.8996 41.5041 26.7513 41.5041C25.4213 41.5078 24.1936 41.1251 23.0606 40.3596Z"
				fill="#1A73E8"
			/>
			<path
				d="M39.1991 27.308L36.3266 29.396L34.8828 27.2058L40.0631 23.4692H42.0488V41.094H39.1991V27.308Z"
				fill="#1A73E8"
			/>
			<path
				d="M47.1584 60.799L60.8004 47.157L53.9794 44.1255L47.1584 47.157L44.127 53.978L47.1584 60.799Z"
				fill="#EA4335"
			/>
			<path d="M13.8086 53.9807L16.8401 60.8017H47.1558V47.1597H16.8401L13.8086 53.9807Z" fill="#34A853" />
			<path
				d="M7.74645 3.2002C5.23423 3.2002 3.19922 5.2352 3.19922 7.74743V47.1579L10.0202 50.1894L16.8412 47.1579V16.8422H47.1569L50.1884 10.0212L47.1572 3.2002H7.74645Z"
				fill="#4285F4"
			/>
			<path
				d="M3.19922 47.1597V56.2544C3.19922 58.7669 5.23423 60.8017 7.74645 60.8017H16.8412V47.1597H3.19922Z"
				fill="#188038"
			/>
			<path d="M47.1562 16.8406V47.1563H60.7982V16.8406L53.9772 13.8091L47.1562 16.8406Z" fill="#FBBC04" />
			<path
				d="M60.7982 16.8417V7.74694C60.7982 5.23443 58.7632 3.19971 56.251 3.19971H47.1562V16.8417H60.7982Z"
				fill="#1967D2"
			/>
		</svg>
	);
};
